<template>
    <div>
    <div name="navbar-top" class="bg-black text-white fixed w-full" style="display: flex; height: 10vh;">
        <div style="border-color: black; border: 2px; padding-left: 2%; justify-content: space-between;" class="navbar shadow-sm" >
            <a @click="this.currentPage = 'fund'" class="font-bold p-2 m-2 bg-black text-white rounded-xs break-all items-center" style="display: flex; flex-direction: column; height: 100%;">
                <label class="text-sm font-semibold" style="height: 50%;" >Credits</label>  
                <label class="text-sm font-thin" style="height: 50%;">{{ credits }}</label>
            </a>
            <div style="display: flex; flex-direction: row; height:100%; justify-content: right;">
            <a class="flex flex items-center justify-center" href="mailto:info@getreferral.in" >
            <svg class="size-[1.5em] pr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentcolor"><path d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48L48 64zM0 176L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-208L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z"/></svg>
            </a>
            <div class="flex flex items-center justify-center">
            <span class="mr-2 text-xs">Contact Us</span>
            </div>
            <button class="text-white pr-2" style="justify-content: center; height: 100%;" @click="logout">
                <svg class="size-[1.2em]" xmlns="http://www.w3.org/2000/svg" fill="currentcolor" width="800px" height="800px" viewBox="0 0 32 32" version="1.1"><path d="M3.651 16.989h17.326c0.553 0 1-0.448 1-1s-0.447-1-1-1h-17.264l3.617-3.617c0.391-0.39 0.391-1.024 0-1.414s-1.024-0.39-1.414 0l-5.907 6.062 5.907 6.063c0.196 0.195 0.451 0.293 0.707 0.293s0.511-0.098 0.707-0.293c0.391-0.39 0.391-1.023 0-1.414zM29.989 0h-17c-1.105 0-2 0.895-2 2v9h2.013v-7.78c0-0.668 0.542-1.21 1.21-1.21h14.523c0.669 0 1.21 0.542 1.21 1.21l0.032 25.572c0 0.668-0.541 1.21-1.21 1.21h-14.553c-0.668 0-1.21-0.542-1.21-1.21v-7.824l-2.013 0.003v9.030c0 1.105 0.895 2 2 2h16.999c1.105 0 2.001-0.895 2.001-2v-28c-0-1.105-0.896-2-2-2z"/></svg>
            </button>
        </div>
        </div>
    </div>
    <span style="background-color: white; display: flex; width: 100%; height:0.1rem"></span>
    <div style="display: flex; height: 100vh; flex-direction: column;" class="bg-black pt-20">
    <myRequest v-if="currentPage === 'placed'" :requests="requests" @update-credits="credits += $event" @push-alert="showAlertMessage" />
    <openRequest v-if="currentPage === 'open'" :requests="requests" @push-alert="showAlertMessage" />
    <acceptedRequest v-if="currentPage === 'accepted'" :requests="requests" @push-alert="showAlertMessage" />
    <placeRequest v-if="currentPage === 'place'" @update-credits="credits += $event" @push-alert="showAlertMessage"/> 
    <profilePage v-if="currentPage === 'profile'" @push-alert="showAlertMessage" />
    <fundsPage v-if="currentPage === 'fund'" @update-credits="credits += $event" @push-alert="showAlertMessage"/>
    </div>

    <div name="navbar-bottom" style="height: 10vh; background-color: black;" >           
        <transition name="fade">
        <div v-show="showAlertSuccess" class="dock mb-16 text-white font-sm text-sm text-center" style="height: 6vh; background-color: #e62525;" >        
        <span style="max-width: 100vh;" class="text-white w-full items-center justify-center">{{ alertMessage }}</span>
        </div>    
        </transition>
        <transition name="fade">
        <div v-show="showAlertError" class="dock mb-16 text-white font-sm text-sm  text-center" style="height: 6vh; background-color:#238636;" >        
        <span style="max-width: 100vh;" class="text-white w-full items-center justify-center">{{ alertMessage }}</span>
        </div>
        </transition>    
        <div v-show="true" style="justify-content: space-around; color: white; background-color: black; border-color: white; border: 2px" class="dock bg-neutral text-neutral-content" >        
        <button @click="this.currentPage = 'placed'" :class="['', currentPage === 'placed' ? 'text-white' : 'text-[#3b3939] font-bold']" >
            <svg class="size-[1em]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g fill="currentColor" stroke-linejoin="miter" stroke-linecap="butt"><polyline points="3 14 9 14 9 17 15 17 15 14 21 14" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="2"></polyline><rect x="3" y="3" width="18" height="18" rx="2" ry="2" fill="none" stroke="currentColor" stroke-linecap="square" stroke-miterlimit="10" stroke-width="2"></rect></g></svg>
            <span class="dock-label">Placed</span>
        </button>

        <button  @click="this.currentPage = 'accepted'" :class="['', currentPage === 'accepted' ? 'text-white' : 'text-[#3b3939] font-bold']">
        <svg class="size-[1em]" xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="800px" height="800px" viewBox="0 0 32 32" data-name="Layer 1" id="Layer_1"><title/><path d="M23.93,2H8.07a2.8,2.8,0,0,0-2.8,2.8V27.2A2.8,2.8,0,0,0,8.07,30H23.93a2.8,2.8,0,0,0,2.8-2.8V4.8A2.8,2.8,0,0,0,23.93,2Zm.94,25.2a.94.94,0,0,1-.94.93H8.07a.94.94,0,0,1-.94-.93V4.8a.94.94,0,0,1,.94-.93H23.93a.94.94,0,0,1,.94.93Z"/><path d="M21,11.54l-7.41,7L11,16.14A.93.93,0,1,0,9.76,17.5l3.15,3a.94.94,0,0,0,1.28,0l8-7.56A.93.93,0,1,0,21,11.54Z"/></svg>            
        <span class="dock-label">Accepted</span>
        </button>

        <button @click="this.currentPage = 'open'" :class="['', currentPage === 'open' ? 'text-white' : 'text-[#3b3939] font-bold']">
            <svg class="size-[1em]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g fill="currentColor" stroke-linejoin="miter" stroke-linecap="butt"><polyline points="1 11 12 2 23 11" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="2"></polyline><path d="m5,13v7c0,1.105.895,2,2,2h10c1.105,0,2-.895,2-2v-7" fill="none" stroke="currentColor" stroke-linecap="square" stroke-miterlimit="10" stroke-width="2"></path><line x1="12" y1="22" x2="12" y2="18" fill="none" stroke="currentColor" stroke-linecap="square" stroke-miterlimit="10" stroke-width="2"></line></g></svg>
            <span class="dock-label">Home</span>
        </button>
                
        <button @click="this.currentPage = 'place'" :class="['', currentPage === 'place' ? 'text-white' : 'text-[#3b3939] font-bold']">
            <svg class="size-[1em]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><title/><g data-name="Layer 10" id="Layer_10"><path fill="currentColor" d="M28.7,14.23,4.43,2.1A2,2,0,0,0,1.65,4.41L5,16,1.65,27.59a2,2,0,0,0,1.89,2.53,1.92,1.92,0,0,0,.89-.22h0L28.7,17.77a2,2,0,0,0,0-3.54Z"/></g></svg>
            <span class="dock-label">Reqeuest</span>
        </button>
                <button @click="this.currentPage = 'profile'" :class="['', currentPage === 'profile' ? 'text-white' : 'text-[#3b3939] font-bold']">
            <svg class="size-[1em]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 426.67 426.67" ><g fill="currentColor"><path d="M213.333333,0 C269.912851,0 324.175019,22.4761259 364.18278,62.4838867 C404.190541,102.491647 426.666667,156.753816 426.666667,213.333333 C426.666667,331.15408 331.15408,426.666667 213.333333,426.666667 C95.5125867,426.666667 0,331.15408 0,213.333333 C0,95.5125867 95.5125867,0 213.333333,0 Z M234.666667,234.666667 L192,234.666667 C139.18529,234.666667 93.8415802,266.653822 74.285337,312.314895 C105.229171,355.70638 155.977088,384 213.333333,384 C270.689579,384 321.437496,355.70638 352.381644,312.31198 C332.825087,266.653822 287.481377,234.666667 234.666667,234.666667 L234.666667,234.666667 Z M213.333333,64 C177.987109,64 149.333333,92.653776 149.333333,128 C149.333333,163.346224 177.987109,192 213.333333,192 C248.679557,192 277.333333,163.346224 277.333333,128 C277.333333,92.653776 248.679557,64 213.333333,64 Z"/></g></svg>
            <span class="dock-label">Profile</span>
        </button>
        </div>
    </div>
    </div>
</template>

<script>

import { apiCall } from "../js/main"
import myRequest from "@/components/placed.vue";
import openRequest from "@/components/open.vue";
import acceptedRequest from "@/components/accepted.vue";
import placeRequest from "@/components/place.vue";
import profilePage from "@/components/profile.vue";
import fundsPage from "@/components/funds.vue";

const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default {
    components: {
            myRequest: myRequest,
            openRequest: openRequest,
            acceptedRequest: acceptedRequest,
            placeRequest: placeRequest,
            profilePage: profilePage,
            fundsPage: fundsPage
        },
    data() {
        return { credits: 0,
            currentPage: "",
            alertMessage: "",
            showAlertSuccess: null,
            showAlertError: null

         }
    },
    methods: {
        async showAlertMessage(success, message){
            this.alertMessage = message

            if (success){
                this.showAlertError = true
            }
            else{
                this.showAlertSuccess = true
            }
            setTimeout(() => {
                    this.showAlertSuccess = false;
                    this.showAlertError = false;
                    this.alertMessage = null;
                }, 3000);           
            
        },
       togglePassword() {
        const input = this.$refs.passwordInput;
        input.type = input.type === 'password' ? 'text' : 'password';
        },
       async login(){
        const input = this.$refs.loginBtn;
        input.disabled = true
            
        var data = await apiCall("/user/login", "POST", 
                    {email: this.email,
                    password: this.password})

        if (data.success) {
            this.$router.push('/dashboard'); 
        }

        else{
            console.log(data.error_message)
            input.disabled = false
        }       

        },
        logout(){            
            localStorage["token"] = null
            document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            this.$router.push('/login'); 

        }
    },
    computed: {
       },
    async beforeMount(){
        try {
        var data = await apiCall("/user", "GET", null)
        if (data.success == true){
        console.log(data)
        this.currentPage = 'placed'
        this.credits = data.data.credits
        localStorage["company"] = data.data.company.split(".")[0].replace(/^./, c => c.toUpperCase())
        }        
        else{
         localStorage["token"] = null   
        }
       }
        catch (err) {
            console.warn("API failed or redirected:", err.message);
            // Optionally: show error toast, etc.
        }

    }
}
</script>

<style >
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-leave-to {
  opacity: 0;
}
</style>
